import { responsiveFontSizes, createTheme as createMuiTheme } from '@mui/material';
import { THEMES } from 'src/constants';
import { lightPalette, darkPalette } from './palettes';
import { typography } from './typography';
import { softShadows, strongShadows } from './shadows';
import { componentOverrides } from './components';
import { designTokens } from './tokens';

const createBaseTheme = (palette, shadows) => ({
  direction: 'ltr',
  typography,

  spacing: designTokens.spacing.sm,

  shape: {
    borderRadius: designTokens.borderRadius.medium,
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },

  palette,
  shadows,
  components: {
    ...componentOverrides,

    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            opacity: 0.7,
            color: palette.text.secondary,
          },
        },
      },
    },
  },
});

const themeConfigs = {
  [THEMES.LIGHT]: {
    palette: lightPalette,
    shadows: softShadows,
  },
  [THEMES.DARK]: {
    palette: darkPalette,
    shadows: strongShadows,
  },
};

export const createTheme = (config = {}) => {
  const selectedTheme = config.theme || THEMES.LIGHT;
  const themeConfig = themeConfigs[selectedTheme];

  if (!themeConfig) {
    console.warn(new Error(`The theme ${selectedTheme} is not valid`));
    return createMuiTheme(createBaseTheme(lightPalette, softShadows));
  }

  let theme = createMuiTheme(createBaseTheme(themeConfig.palette, themeConfig.shadows));

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};

export { designTokens } from './tokens';
export { THEMES } from 'src/constants';
